import { render } from "./aio-login-submit-button.vue?vue&type=template&id=e6628ee4&scoped=true"
import script from "./aio-login-submit-button.vue?vue&type=script&lang=js"
export * from "./aio-login-submit-button.vue?vue&type=script&lang=js"

import "./aio-login-submit-button.vue?vue&type=style&index=0&id=e6628ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6628ee4"]])

export default __exports__